import React from "react";
import Paper from "@material-ui/core/Paper";
import ListItemText from "@material-ui/core/ListItemText";
import {BASE_URL_API, MARKET_BASE_URL_API} from "../Const";
import GridList from "@material-ui/core/GridList";
import AppBar from "@material-ui/core/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import ListItem from "@material-ui/core/ListItem";
import {Link} from "react-router-dom";
import {FormPropsTextFields,BackButton} from './HookUtils'
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import {BasketComponent} from "./BasketComponent";

export class AllMarketComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            marketList: [],
        }
    }

    componentDidMount() {
        fetch(BASE_URL_API + 'markets?category_id=' + this.props.child_category_id, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    this.setState({marketList: results.data})
                },
                (error) => {
                    console.log("error")
                }
            );
    }

    render() {

        return (<div>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <ShoppingBasketOutlinedIcon style={{color: 'black'}}/>
                        {
                            this.state.marketList.length > 0 ?
                                <ListItemText align="center"><strong style={{
                                    fontSize: 18,
                                    overflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    color: 'black'
                                }} >{this.state.marketList[0].category.title}</strong></ListItemText>
                                : ""
                        }

                        <IconButton component={Link} to={"/search"} style={{color: 'black'}}><SearchIcon/></IconButton>

                        <IconButton style={{color: 'black'}}> <BasketComponent/></IconButton>

                        <BackButton/>
                    </ToolbarMui>

                </AppBar>


                <GridList cellHeight={220} style={{marginTop: 90, marginBottom: 70, overflow: 'hidden'}}>

                    {
                        this.state.marketList.map((market) => (

                            <ListItem key={market.id} style={{width: 170}} component={Link}
                                      to={"/market/?id=" + market.id}>

                                <div style={{width: 150}}>
                                    <Paper style={{
                                        width: 150,
                                        height: 140,
                                        align: 'center',
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        backgroundImage: 'url(' + (market.pictures.length > 0 ? MARKET_BASE_URL_API + market.pictures[0].url : "https://hamekara.com/hamekara-logo.png") + ')'
                                    }}>


                                    </Paper>
                                    <ListItemText>
                                        <p key={market.id}
                                           style={{overflow: 'ellipsis', whiteSpace: 'nowrap', color: 'black'}}
                                           align='center'>{market.name}</p>
                                    </ListItemText>
                                </div>
                            </ListItem>

                        ))
                    }
                </GridList>

                <FormPropsTextFields/>
            </div>
        );
    }
}
